
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexNw20Ic_45pA8g1PhW_45kW45wuwRjc4d1PldiLa5zbxIkvcMeta } from "/tmp/tmprnfrf_6g/pages/[area]/[pref]/[id]/index.vue?macro=true";
import { default as index2dtMxqN2Jvk4K__tWVO_3Jb8YaD7r5ZBJ2_459l5uWdSAMeta } from "/tmp/tmprnfrf_6g/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexO_457CSJ_wRm5wNpz8l3tc3CheXiZeVwYmGdJiVZvtHMQMeta } from "/tmp/tmprnfrf_6g/pages/[area]/index.vue?macro=true";
import { default as index22zkkIwKh8tO5OUK_45tfdD91Rrx_JYXERLUVWuODWIxoMeta } from "/tmp/tmprnfrf_6g/pages/index.vue?macro=true";
import { default as indexYw4j7_459b7a3O_45ONWdmy9jQq9KYhgGoMMncuJC8_UHgkMeta } from "/tmp/tmprnfrf_6g/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexqBwRNRFADGxeHrhrWh2xSvKkyKDkTPfrKxpXgEXpHwsMeta } from "/tmp/tmprnfrf_6g/pages/okinawa/index.vue?macro=true";
import { default as index4BOhAZKN0D4iV6tLa8gELm_45zvMWfgBnuVv2U00cnSj4Meta } from "/tmp/tmprnfrf_6g/pages/zoom-map/index.vue?macro=true";
export default [
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmprnfrf_6g/pages/[area]/[pref]/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmprnfrf_6g/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmprnfrf_6g/pages/[area]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmprnfrf_6g/pages/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmprnfrf_6g/pages/okinawa/[id]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmprnfrf_6g/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmprnfrf_6g/pages/zoom-map/index.vue")
  }
]